import { useEffect, useState } from 'react'
import { getSchedule } from '../../services/Schedule';
import { formatDateForDisplay } from '../../utils/getUserDateFormat';
import Cookies from 'js-cookie';

const ViewMemberSchedule = ({ id }: { id: string }) => {
    const token = Cookies.get("token-my-cdir");
    const [scheduleData, setScheduleData] = useState<any>({
        activityName: "",
        date: "",
        startTime: "",
        endTime: "",
        location: "",
        language: "",
        description: ""
    });

    const formatTime = (time: string) => {
        if (!time) return "";

        const [hour, minute] = time.split(":");
        let h = parseInt(hour, 10);

        const ampm = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12;

        return `${h.toString().padStart(2, "0")}:${minute} ${ampm}`;
    };

    useEffect(() => {
        if (id) {
            getSchedule(id, token!.toString())
                .then(res => {
                    setScheduleData({
                        ...res,
                        activityName: res?.activityName?.trim(),
                        location: res?.location?.trim(),
                        language: res?.language?.trim(),
                        date: res?.date ? formatDateForDisplay(res.date) : "",
                        startTime: res?.startTime ? formatTime(res.startTime) : "",
                        endTime: res?.endTime ? formatTime(res.endTime) : ""
                    });
                })
                .catch(error => console.log(error));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    return (
        <div className="w-full relative">
            <div className="py-10 px-8 space-y-6">

                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-bold text-secondary">
                        {scheduleData.activityName || "Schedule"}
                    </h2>

                    <button
                        onClick={() => window.dispatchEvent(new Event("closeEventModal"))}
                        className="text-gray-500 hover:text-black text-lg"
                    >
                        ✕
                    </button>
                </div>

                {/* Date */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-semibold mb-2">Date</h3>
                    <p>{scheduleData.date || "-"}</p>
                </div>

                {/* Time */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-semibold mb-2">Time</h3>
                    <p>
                        {scheduleData.startTime || "-"} - {scheduleData.endTime || "-"}
                    </p>
                </div>

                {/* Location */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-semibold mb-2">Location</h3>
                    <p>{scheduleData.location || "-"}</p>
                </div>

                {/* Language */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-semibold mb-2">Language</h3>
                    <p>{scheduleData.language || "Not specified"}</p>
                </div>

                {/* Description */}
                <div className="border rounded-lg p-4">
                    <h3 className="font-semibold mb-2">Description</h3>
                    <p className="whitespace-pre-line">
                        {scheduleData.description || "-"}
                    </p>
                </div>

            </div>
        </div>
    );
}

export default ViewMemberSchedule